import { render, staticRenderFns } from "./scoreStatistic.vue?vue&type=template&id=73011fad&scoped=true&"
import script from "./scoreStatistic.vue?vue&type=script&lang=js&"
export * from "./scoreStatistic.vue?vue&type=script&lang=js&"
import style0 from "./scoreStatistic.vue?vue&type=style&index=0&id=73011fad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73011fad",
  null
  
)

export default component.exports